// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app {
  height: 100%;
}
* {
  box-sizing: border-box;
}
.el-tabs__item {
  line-height: 28px !important;
  height: 28px !important;
}
.el-tabs__header {
  margin-bottom: 4px !important;
}
.v-modal {
  opacity: 0.05 !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav .is-active {
  background-color: #c4edff !important;
  color: #333 !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.vue","webpack://./App.vue"],"names":[],"mappings":"AACA;EACE,YAAA;ACAF;ADEA;EACE,sBAAA;ACAF;ADEA;EACE,4BAAA;EACA,uBAAA;ACAF;ADEA;EACE,6BAAA;ACAF;ADGA;EACE,wBAAA;ACDF;ADIA;EACE,oCAAA;EACA,sBAAA;ACFF","sourcesContent":["\n#app {\n  height: 100%;\n}\n* {\n  box-sizing: border-box;\n}\n.el-tabs__item {\n  line-height: 28px !important;\n  height: 28px !important;\n}\n.el-tabs__header {\n  margin-bottom: 4px !important;\n}\n\n.v-modal {\n  opacity: 0.05 !important;\n}\n\n.el-tabs--card > .el-tabs__header .el-tabs__nav .is-active {\n  background-color: #c4edff !important;\n  color: #333 !important;\n}\n","#app {\n  height: 100%;\n}\n* {\n  box-sizing: border-box;\n}\n.el-tabs__item {\n  line-height: 28px !important;\n  height: 28px !important;\n}\n.el-tabs__header {\n  margin-bottom: 4px !important;\n}\n.v-modal {\n  opacity: 0.05 !important;\n}\n.el-tabs--card > .el-tabs__header .el-tabs__nav .is-active {\n  background-color: #c4edff !important;\n  color: #333 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
